export const MODAL_HEIGHT = 600;
export const MODAL_WIDTH = 960;
